module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-4-en.5da45248.png";